import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { useMediaQuery } from '@material-ui/core';
import ListAlt from '@material-ui/icons/ListAlt';
import SendOutlined from '@material-ui/icons/SendOutlined';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import Close from '@material-ui/icons/Close';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { DataGrid, GridOverlay, useGridSlotComponentProps } from '@material-ui/data-grid'
import Pagination from '@material-ui/lab/Pagination'
import Autocomplete from '@material-ui/lab/Autocomplete'

import UpdateProcessModalSuccess from '../../../components/admin/standard-report-organization/update-process-modal-success'
import UpdateProcessModalFailed from '../../../components/admin/standard-report-organization/update-process-modal-failed'
import ConfirmSendNotifyModal from './components/confirmSendNotifyModal'
import SelectOperatorModal from './components/SelectOperatorModal'

// import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { useTheme } from '@material-ui/core/styles'
import { useStoreState, useStoreRehydrated } from '../../../store'

import { dataSetReports, adminQoS } from 'api/index'
import { set } from 'date-fns'
import { toThaiYear } from '../../../utils/thaiDate'

const useStyles = makeStyles(theme => {
	return {
		card_styles: {
			height: '80vh',
		},
		details_button: {
			backgroundColor: '#466AE9',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#466AE9',
			},
		},
		approve_button: {
			backgroundColor: '#1DBF73',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#1DBF73',
			},
		},
		wait_button: {
			backgroundColor: '#F6B50B',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#F6B50B',
			},
		},
		reject_button: {
			backgroundColor: '#DB4D44',
			color: '#fff',
			'&:hover': {
				backgroundColor: '#DB4D44',
			},
		},
		type_of_report: {
			backgroundColor: '#c8e8ff',
			color: '#028BFF',
			borderColor: '#84BFF0',
		},
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
	}
})

function CustomPagination() {
	const { state, apiRef } = useGridSlotComponentProps()

	return (
		<Grid className="flex flex-row items-center w-full justify-between px-2">
			<Grid className="flex flex-row items-center">
				<Typography variant="body2" className="mr-2">Rows per page:</Typography>
				<Select
					value={state.pagination.pageSize}
					onChange={(e) => apiRef.current.setPageSize(e.target.value)}
					disableUnderline
				>
					{[5, 8, 10, 20, 100].map((size) => (
						<MenuItem key={size} value={size}>
							{size}
						</MenuItem>
					))}
				</Select>
			</Grid>
			<Pagination
				className="p-2"
				color="primary"
				count={state.pagination.pageCount}
				page={state.pagination.page + 1}
				onChange={(event, value) => apiRef.current.setPage(value - 1)}
				showFirstButton
				showLastButton
			/>
		</Grid>
	)
}

// Page Description: Lists of Organization who don't send their report either of in time and on time
export default function StandardReportOrganization() {
	// const history = useHistory()
	const [pageSize, setPageSize] = useState(8)
	const isRehydrated = useStoreRehydrated()
	const classes = useStyles()
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
	const isMobile2 = useMediaQuery('(min-width:425px)')
	const [rows, setRows] = useState([])
	const [isDataLoading, setIsDataLoading] = useState(false)
	const admin = useStoreState(s => s.QoSAdminModel.admin)
	const [signature, setSignature] = useState([]);
	const [selected, setSelected] = useState('');
	// Current dataSetReportID
	const [currentDataSetReportID, setCurrentDataSetReportID] = useState(null)
	// Sending Modal States
	const [sureModalText, setSureModalText] = useState({
		title: '',
		content: '',
	})
	const [openSureModal, setOpenSureModal] = useState(false)
	const [openUpdateProcessModalSuccess, setOpenUpdateProcessModalSuccess] =
		useState(false)
	const [openUpdateProcessModalFailed, setOpenUpdateProcessModalFailed] =
		useState(false)
	const [sendingSuccessLabel, setSendingSuccessLabel] = useState('')
	const [sendingFailedLabel, setSendingFailedLabel] = useState('')
	const [isSetToProcess, setIsSetToProcess] = useState(true)
	// Table Width
	const [columnsId, setColumnsId] = useState([80, 0])
	const [columnsName, setColumnsName] = useState([360, 0])
	const [columnsWorkStatusId, setColumnsWorkStatusId] = useState([200, 0])

	// Keep Search Text
	const [searchText, setSearchText] = useState('');
	const [rowsData, setRowsData] = useState([])

	// Notification Logic
	const [openSelectModal, setOpenSelectModal] = useState(false);
	const [selectModalType, setSelectModalType] = useState('sms');
	const [notificationHistory, setNotificationHistory] = useState([]);
	const [notificationRecipients, setNotificationRecipients] = useState([]); // Store separately
	const [groupingMode, setGroupingMode] = useState('none');
	const [selectedGroupKey, setSelectedGroupKey] = useState('');

	// Get unique keys for the second dropdown
	const groupKeys = React.useMemo(() => {
		if (groupingMode === 'none') return [];
		const keys = new Set();
		rowsData.forEach(row => {
			const key = groupingMode === 'year_quarter' ? row.yearNQuarter : row.operatorName;
			keys.add(key);
		});
		return Array.from(keys).sort();
	}, [groupingMode, rowsData]);

	// Reset selectedGroupKey when groupingMode changes
	useEffect(() => {
		if (groupingMode !== 'none' && groupKeys.length > 0) {
			setSelectedGroupKey(groupKeys[0]);
		} else {
			setSelectedGroupKey('');
		}
	}, [groupingMode, groupKeys]);

	/** <-----------------------------------------------------------------------> */

	// Setting Process Function Handler

	// roleID: 1 and roleID: 2
	const onUpdateSetToProcess = async () => {
		const res = await dataSetReports.updateAdminProcess(
			currentDataSetReportID,
			{
				isSetToProcess: 'y',
			}
		)

		if (res && res.status === 200) {
			setSendingSuccessLabel('ส่งให้ผู้ออกหนังสือเร่งรัดสำเร็จ')
			onOpenUpdateProcessModalSuccess()
		} else if (res && res.response.status === 400) {
			setSendingFailedLabel(
				'ส่งให้ผู้ออกหนังสือเร่งรัดไม่สำเร็จ โปรดลองอีกครั้ง'
			)
			onOpenUpdateProcessModalFailed()
		}
	}

	// roleID: 1 and roleID: 7
	const onUpdateSentNotify = async () => {

		const res = await dataSetReports.updateAdminProcess(
			currentDataSetReportID,
			{
				isSentNotify: 'y',
				signatureID: selected
			}
		)

		if (res && res.status === 200) {
			setSendingSuccessLabel('ออกหนังสือเร่งรัดสำเร็จ')
			onOpenUpdateProcessModalSuccess()
		} else {
			setSendingFailedLabel('ออกหนังสือเร่งรัดไม่สำเร็จ โปรดลองอีกครั้ง')
			onOpenUpdateProcessModalFailed()
		}
	}

	const onAskUpdateProcessSetToProcess = () => {
		setIsSetToProcess(true)
		setSureModalText({
			title: 'ส่งให้ผู้ออกหนังสือเร่งรัด',
			content: 'คุณแน่ใจที่จะส่งให้ผู้ออกหนังสือเร่งรัดหรือไม่?',
		})
		setOpenSureModal(true)
	}

	const onAskUpdateProcessSentNotify = () => {
		setIsSetToProcess(false)
		setSureModalText({
			title: 'ออกหนังสือเร่งรัด',
			content: 'คุณแน่ใจที่จะออกหนังสือเร่งรัดหรือไม่?',
		})
		setOpenSureModal(true)
	}

	const onOpenUpdateProcessModalSuccess = () =>
		setOpenUpdateProcessModalSuccess(!openUpdateProcessModalSuccess)

	const onOpenUpdateProcessModalFailed = () =>
		setOpenUpdateProcessModalFailed(!openUpdateProcessModalFailed)

	const selectSignature = ID => {
		setSelected(ID)
	}

	/** <-----------------------------------------------------------------------> */

	// Main Rendering

	var columns = [
		{
			field: 'id',
			headerName: 'ลำดับ',
			width: columnsId[0],
			flex: columnsId[1],
			headerAlign: 'left',
			align: 'left',
			sortable: true,
			editable: false,
			renderCell: params => {
				return <Grid className="pl-4">{params.value}</Grid>
			},
		},
		{
			field: 'operatorName',
			headerName: 'ผู้ประกอบการ',
			width: columnsName[0],
			flex: columnsName[1],
			headerAlign: 'left',
			align: 'left',
			editable: false,
		},
		{
			field: 'yearNQuarter',
			headerName: 'ปีและไตรมาส',
			width: columnsWorkStatusId[0],
			flex: columnsWorkStatusId[1],
			headerAlign: 'left',
			align: 'left',
			editable: false,
		},
		{
			field: 'actions',
			headerName: ' ',
			width: columnsWorkStatusId[0],
			flex: columnsWorkStatusId[1],
			headerAlign: 'center',
			align: 'center',
			renderCell: params => {
				const roleID = admin?.roleID
				const isSetToProcess = params.row.isSetToProcess
				const isSentNotify = params.row.isSentNotify
				const dataSetReportID = params.row.dataSetReportID

				return (
					<Grid className="flex flex-row justify-center gap-x-2 items-center w-full md:pr-5 md:py-2 p-2">
						{(roleID === 1 || roleID === 2 || roleID === 14 || roleID === 17) && (isSetToProcess === 'n' || isSetToProcess === null) && (
							<Button
								variant="contained"
								size="small"
								color="primary"
								onClick={() => {
									setCurrentDataSetReportID(dataSetReportID)
									onAskUpdateProcessSetToProcess()
								}}>
								เตรียมส่งข้อมูลให้ผู้ออกหนังสือเร่งรัด
							</Button>
						)}
						{/* case: sended to roleID: 7 (ผู้ออกหนังสือเร่งรัด) and admin is roleID: 2 (ผู้เตรียมข้อมูล) */}
						{(roleID === 1 || roleID === 2 || roleID === 14) && isSetToProcess === 'y' && (
							<Button
								variant="contained"
								size="small"
								className={`${classes.approve_button} pointer-events-none`}>
								เตรียมข้อมูลแล้ว
							</Button>
						)}
						{(roleID === 1 || roleID === 7 || roleID === 14 || roleID === 17) &&
							isSetToProcess === 'y' &&
							isSentNotify !== 'y' && (
								<Button
									variant="contained"
									size="small"
									color="primary"
									onClick={() => {
										setCurrentDataSetReportID(dataSetReportID)
										onAskUpdateProcessSentNotify()
									}}>
									ออกหนังสือเร่งรัด
								</Button>
							)}
					</Grid>
				)
			},
		},
	]

	const onLanding = async () => {
		setIsDataLoading(true)
		const res = await dataSetReports.getUnReportDatasetReportsOperator()
		if (res && res.status === 200) {
			const roleID = admin?.roleID
			const response = res.data

			response.sort((a, b) => (b.year - a.year) || (b.quarter - a.quarter))

			const temp = []

			for (let i = 0; i < response.length; i++) {
				// ผู้ออกหนังสือเร่งรัด
				if (roleID === 7 && response[i].isSetToProcess === 'y') {
					temp.push({
						id: i + 1,
						unReportedID: response[i].id,
						operatorName: response[i].operatorName,
						dataSetReportID: response[i].dataSetReportID,
						isSentNotify: response[i].isSentNotify,
						isSetToProcess: response[i].isSetToProcess,
						yearNQuarter: toThaiYear(response[i].year) + '/' + response[i].quarter,
					})
				} else {
					// superadmin and ผู้เตรียมข้อมูล
					temp.push({
						id: i + 1,
						unReportedID: response[i].id,
						operatorName: response[i].operatorName,
						dataSetReportID: response[i].dataSetReportID,
						isSentNotify: response[i].isSentNotify,
						isSetToProcess: response[i].isSetToProcess,
						yearNQuarter: toThaiYear(response[i].year) + '/' + response[i].quarter,
					})
				}
			}

			setRowsData(temp)
			setRows(temp)
		}
		setIsDataLoading(false)
	}

	const fetchHistory = async () => {
		const res = await dataSetReports.getNotificationHistory();
		if (res && res.status === 200) {
			setNotificationHistory(res.data);
		}
	}

	const onSearhResult = (e) => {
		const { value } = e.target
		// Save to local storage
		localStorage.setItem('searchTextStandardReportOrganization', value);

		const searchedResults = rowsData.filter(row => {
			return row.operatorName.includes(value)
		})

		setRows(searchedResults)
	}

	/** <-----------------------------------------------------------------------> */

	useEffect(() => {
		if (isMobile) {
			setColumnsId([80, 0])
			setColumnsName([360, 0])
			setColumnsWorkStatusId([200, 0])
		} else {
			setColumnsId([0, 0.2])
			setColumnsName([0, 1.2])
			setColumnsWorkStatusId([0, 0.8])
		}
	}, [isMobile])

	useEffect(() => {
		if (isRehydrated) {
			const savedSearch = localStorage.getItem('searchTextStandardReportOrganization') || '';
			if (savedSearch) {
				setSearchText(savedSearch);
			}
			if (savedSearch) {
				setSearchText(savedSearch);
			}
			onLanding();
			fetchHistory();
			adminQoS.getSignature().then(e => {
				setSignature(e);
			})
		}
		// eslint-disable-next-line
	}, [isRehydrated])

	useEffect(() => {
		if (rowsData.length > 0 && searchText) {
			const searchedResults = rowsData.filter(row => {
				return row.operatorName.includes(searchText)
			})
			setRows(searchedResults)
		}
	}, [rowsData])

	const handleSendNotification = async (type) => {
		setSelectModalType(type);
		setOpenSelectModal(true);
		// Fetch recipients freshly to get latest contact info/status
		setIsDataLoading(true);
		const res = await dataSetReports.getRecipientsForNotification();
		if (res && res.status === 200) {
			setNotificationRecipients(res.data);
		}
		setIsDataLoading(false);
	}

	const handleModalSend = async (selectedIds, type) => {
		setOpenSelectModal(false);
		setIsDataLoading(true);
		const res = await dataSetReports.sendQuarterlyNotification(selectedIds, type);
		setIsDataLoading(false);
		fetchHistory(); // Refresh history

		if (res && res.status === 200) {
			const sentList = res.data.sentOperators && res.data.sentOperators.length > 0
				? `<div style="max-height: 200px; overflow-y: auto; text-align: left;"><ul style="list-style-type: disc; padding-left: 20px;">${res.data.sentOperators.map(op => `<li>${op}</li>`).join('')}</ul></div>`
				: 'ไม่พบผู้ประกอบการที่ได้รับแจ้งเตือน';

			Swal.fire({
				title: `ส่งข้อความแจ้งเตือน ${type.toUpperCase()} สำเร็จ`,
				html: `
                    <p>${res.data.message}</p>
                    <br/>
                    <p><strong>ผู้ประกอบการที่ได้รับแจ้งเตือน:</strong></p>
                    ${sentList}
                `,
				icon: 'success'
			})
		} else {
			Swal.fire(
				'เกิดข้อผิดพลาด',
				'ส่งข้อความแจ้งเตือนไม่สำเร็จ',
				'error'
			)
		}
	}

	return (
		<>
			<Grid className="lg:p-10">
				<Card
					className={`${classes.card_styles} lg:border-t-4 border-card_top_border`}>
					<Grid className="flex flex-col justify-start items-start overflow-auto h-full w-full">
						<Grid className="flex flex-row items-center justify-between mt-4 mb-3 px-5 w-full">
							<Grid className="flex flex-row items-center">
								<Grid>
									<ListAlt style={{ fontSize: 22 }} className="mr-1" />
								</Grid>
								<Grid className="font-bold text-sm text-card_header_color">
									รายชื่อผู้ประกอบการที่ยังไม่ส่งรายงานมาตรฐาน
								</Grid>
							</Grid>



							<Grid className="flex flex-row items-center gap-x-2">
								<Typography variant="body2">แสดงผลตาม:</Typography>
								<Select
									value={groupingMode}
									onChange={(e) => setGroupingMode(e.target.value)}
									variant="outlined"
									margin="dense"
									className="bg-white mr-2"
									style={{ height: 40, minWidth: 150 }}
								>
									<MenuItem value="none">ไม่ระบุกลุ่ม</MenuItem>
									<MenuItem value="year_quarter">ปีและไตรมาส</MenuItem>
									<MenuItem value="operator">ผู้ประกอบการ</MenuItem>
								</Select>
								{groupingMode !== 'none' && (
									<Autocomplete
										value={selectedGroupKey}
										onChange={(event, newValue) => {
											if (newValue) setSelectedGroupKey(newValue);
										}}
										options={groupKeys}
										getOptionLabel={(option) => option}
										renderInput={(params) => (
											<TextField
												{...params}
												label={groupingMode === 'year_quarter' ? 'เลือกปี/ไตรมาส' : 'เลือกผู้ประกอบการ'}
												variant="outlined"
												margin="dense"
												className="bg-white mr-2"
												style={{ minWidth: 250 }}
											/>
										)}
										disableClearable
									/>
								)}
								<TextField
									className="w-full lg:w-96"
									size="small"
									placeholder="ค้นหาโดย ชื่อผู้ประกอบการ"
									value={searchText}
									onChange={e => {
										setSearchText(e.target.value);
										onSearhResult(e);
									}}
									label=""
									variant="outlined"
									InputProps={{
										startAdornment: (
											<SearchOutlined style={{ color: 'rgba(0,0,0,0.54)', marginRight: 8 }} />
										),
										endAdornment: searchText && (
											<Close
												onClick={() => {
													setSearchText('');
													localStorage.removeItem('searchTextStandardReportOrganization');
													onSearhResult({ target: { value: '' } });
												}}
												style={{
													cursor: 'pointer',
													color: 'rgba(0,0,0,0.54)',
												}}
											/>
										)
									}}
								/>
							</Grid>
						</Grid>
						<Grid className="flex flex-row items-center justify-end px-5 w-full gap-x-2 mb-3">
							<Button
								variant="contained"
								style={{ backgroundColor: '#1DBF73', color: '#fff' }}
								startIcon={<SendOutlined />}
								onClick={() => handleSendNotification('sms')}
							>
								ส่ง SMS แจ้งเตือน
							</Button>
							<Button
								variant="contained"
								color="primary"
								startIcon={<SendOutlined />}
								onClick={() => handleSendNotification('email')}
							>
								ส่ง Email แจ้งเตือน
							</Button>
						</Grid>
						<Grid
							className="md:px-5"
							style={{ minHeight: isMobile2 ? "65vh" : 550, width: '100%' }}>
							<div style={{ height: isMobile2 ? "65vh" : 550, width: '100%' }}>
								<DataGrid
									rows={rows.filter(row => {
										if (groupingMode === 'none') return true;
										const key = groupingMode === 'year_quarter' ? row.yearNQuarter : row.operatorName;
										return key === selectedGroupKey;
									})}
									columns={columns}
									pageSize={pageSize}
									rowsPerPageOptions={[5, 8, 10, 20, 100]}
									onPageSizeChange={size => setPageSize(size)}
									disableSelectionOnClick
									components={{
										Pagination: CustomPagination,
										NoRowsOverlay: () => {
											if (!isDataLoading) {
												return <GridOverlay>ไม่พบข้อมูล</GridOverlay>;
											} else {
												return <GridOverlay>กำลังประมวลผลข้อมูล โปรดรอสักครู่..</GridOverlay>;
											}
										}
									}}
								/>
							</div>
						</Grid>
					</Grid>
				</Card>
			</Grid>
			<UpdateProcessModalSuccess
				open={openUpdateProcessModalSuccess}
				label={sendingSuccessLabel}
				handleButton={() => {
					onLanding()
					onOpenUpdateProcessModalSuccess()
					setOpenSureModal(false)
				}}
			/>
			<UpdateProcessModalFailed
				open={openUpdateProcessModalFailed}
				message={sendingFailedLabel}
				handleButton={() => {
					onLanding()
					onOpenUpdateProcessModalFailed()
					setOpenSureModal(false)
				}}
			/>
			<ConfirmSendNotifyModal
				title={sureModalText.title}
				content={sureModalText.content}
				listSignature={signature}
				isSetToProcess={isSetToProcess}
				selectSignature={selectSignature}
				header_icon={
					<SendOutlined style={{ fontSize: 20 }} className="mr-1 text-white" />
				}
				open={openSureModal}
				handleButton={
					isSetToProcess ? onUpdateSetToProcess : onUpdateSentNotify
				}
				handleCancel={() => setOpenSureModal(false)}
			/>
			<SelectOperatorModal
				open={openSelectModal}
				type={selectModalType}
				operators={notificationRecipients}
				history={notificationHistory}
				onClose={() => setOpenSelectModal(false)}
				onSend={handleModalSend}
			/>
		</>
	)
}
